import { Link } from "react-router-dom";
import { ArrowRight, HardHat } from "lucide-react";
import { Panel } from "@/components/common/ui-kit";

export const TechReportsCard = ({ data }) => (
  <Panel className="p-5" data-testid="dashboard-tech-reports">
    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-500"><HardHat className="h-4 w-4" />Resoconti tecnici da convalidare</div>
    <div className="mt-3 flex items-end justify-between gap-3">
      <div>
        <p className={`font-display text-4xl font-bold ${data.pending ? "text-ink" : "text-slate-300"}`} data-testid="dashboard-tech-reports-count">{data.pending}</p>
        <p className="mt-1 text-xs text-slate-500">{data.pending ? `Il più vecchio è del ${new Date(data.oldest_at).toLocaleDateString("it-IT")}` : "Nessun resoconto in attesa"}</p>
      </div>
      <Link to="/moduli-tecnici" className="flex items-center gap-1 text-sm font-semibold text-brand-700 hover:underline" data-testid="dashboard-tech-reports-link">Convalida<ArrowRight className="h-4 w-4" /></Link>
    </div>
  </Panel>
);
